























import { Vue, Component } from 'vue-property-decorator';
import CardTitle from '@/shared/card/card-title.component.vue';
import AuthorityStore from '@/domain/security/authority.store';
import AuthorityEnum from '@/domain/security/authority.enum';
import DaisyMessage from '@/domain/daisy-message/entity/daisy-message.entity';
import DaisyMessageFilterEntity from '@/domain/daisy-message/entity/daisy-message-filter.entity';
import DaisyMessageService from '@/domain/daisy-message/service/daisy-message.service';
import DaisyMessageErrorHandler from '@/domain/daisy-message/service/daisy-message-error.handler';
import DaisyMessageFilter from './daisy-message-filter.component.vue';
import DaisyMessageTable from './table/daisy-message-table.component.vue';

@Component({
  components: {
    CardTitle,
    DaisyMessageFilter,
    DaisyMessageTable,
  },
})
export default class DaisyMessageView extends Vue {
  messages: DaisyMessage[] = [];

  filter: DaisyMessageFilterEntity = new DaisyMessageFilterEntity();

  loading: boolean = false;

  hasCreateDaisyMessage: boolean = false;

  hasUpdateDaisyMessage: boolean = false;

  hasDeleteDaisyMessage: boolean = false;

  existingLanguages: string[] = [];

  pagination: any = {
    itemsPerPage: 10,
    page: 1,
    total: 0,
    pageCount: 0,
  };

  async created() {
    await this.validationAuthorities();
    this.getMessages();
    this.loadExistingLanguages();
  }

  async validationAuthorities() {
    const authority = await AuthorityStore.fetchedAuthority();
    this.hasCreateDaisyMessage = authority
      .hasAuthorities([AuthorityEnum.CREATE_DAISY_MESSAGE]);
    this.hasUpdateDaisyMessage = authority
      .hasAuthorities([AuthorityEnum.UPDATE_DAISY_MESSAGE]);
    this.hasDeleteDaisyMessage = authority
      .hasAuthorities([AuthorityEnum.DELETE_DAISY_MESSAGE]);
  }

  setFilterValues(value: any) {
    if (this.pagination.itemsPerPage < value.itemsPerPage) {
      value.page = 1;
    }
    this.pagination = value;
    this.getMessages();
    this.loadExistingLanguages();
  }

  getMessages() {
    this.loading = true;
    DaisyMessageService.search(
      this.filter,
      this.pagination.page,
      this.pagination.itemsPerPage,
    ).then(({ data }) => {
      this.messages = data.content.map((it: any) => new DaisyMessage(it));
      this.pagination.total = data.totalElements;
      this.pagination.pageCount = data.totalPages;
    }).catch(DaisyMessageErrorHandler.handle)
      .finally(() => {
        this.loading = false;
      });
  }

  loadExistingLanguages() {
    DaisyMessageService.listLanguages()
      .then((languages) => {
        this.existingLanguages = languages;
      })
      .catch(DaisyMessageErrorHandler.handle);
  }

  sendFilter(filter: DaisyMessageFilterEntity) {
    this.filter = filter;
    this.pagination.page = 1;
    this.getMessages();
    this.loadExistingLanguages();
  }
}
